import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';
import LearnMoreLink from './components/LearnMoreLink';
import { userHasFeature } from '../../helpers/Features';

const EmptyCustomTeams = ({ link }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Organize access with Teams' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Groups your workspace users to give access to files and Collections in just a few clicks.',
          })}
        </div>
        {userHasFeature('custom-teams') ? (
          <Button color="primary" className="mt-4" tag={Link} to={link}>
            {intl.formatMessage({ defaultMessage: 'Create a Team' })}
          </Button>
        ) : (
          <UnlockButton feature="custom-teams" />
        )}
        <LearnMoreLink url="https://help.stockpress.co/en/articles/5937385-creating-teams-in-your-workspace" />
      </Col>
      <EmptyStateVideo video="teams" />
    </div>
  );
};

EmptyCustomTeams.propTypes = {
  link: PropTypes.string,
};

EmptyCustomTeams.defaultProps = {
  link: null,
};

export default EmptyCustomTeams;
